import ErrorPage from 'components/base/ErrorPage';

const Unauthorized = () => {
  return <ErrorPage title="403" details="We’re sorry, but you do not have access to this page" />;
};

export default Unauthorized;
